import { Injectable } from '@angular/core';
import { formatCurrency } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  constructor() {
  }

  formatCurrency(amount, round = false) {
    if (amount) {
      if (round) {
        amount = Math.round(amount);
      }

      const options = { currency: 'USD', minimumFractionDigits: 2, style: 'currency', currencyDisplay: "symbol" }

      if ((amount % 1).toFixed(2) === '0.00') {
        options.minimumFractionDigits = 0;
      }

      if (amount >= 0) {
        return amount.toLocaleString('en-US', options);
      } else {
        return '(' + (-1 * amount).toLocaleString('en-US', options) + ')'
      }
    } else {
      return '$0';
    }
  }
}
